"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ordersLoaded = exports.orders = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const data = (state) => state.orders;
const orders = (state) => data(state).orders;
exports.orders = orders;
const ordersLoaded = (state) => data(state).ordersLoaded;
exports.ordersLoaded = ordersLoaded;
